import ManageAnamnese from '@/views/consultations/en-cours/histoire-de-la-maladie/manage-anamnese'
import store_consultation from "@/store/mods/consultations/consultations"

export default {
    name: 'histoire-de-la-maladie',
    components: {
        ManageAnamnese
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },
    data() {
        return {
            anamnese_is_loading: true,
            is_empty: false,
            data_to_be_deleted: {},
            list_atcd_anamneses: [],
            group_id: 0,

            info_patient: {},
            info_user: {},
            liste_anamneses: []
        }
    },

    watch: {
        evolution_toggler() {
            this.$store.commit("SET_HISTOIRE_DE_LA_MALADIE", [])
            this.$store.commit("SET_HISTOIRE_DE_LA_MALADIE_HISTORIQUE", [])

            this.getHistoireAnamnese()
            this.userInfoSetter()
        }
    },

    computed: {
        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        addAnamnese(group_id) {
            this.list_atcd_anamneses = []
            this.group_id = group_id
        },

        editAnamnese(group_id, anamneses) {
            this.group_id = group_id
            this.list_atcd_anamneses = anamneses
        },

        async getHistoireAnamnese() {
            this.liste_anamneses = []
            this.anamnese_is_loading = true

            let filter_data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                data_type: 'histoire_de_la_maladie',
                est_en_cours: true
            }

            store_consultation.getConsultationAnamneses(filter_data).then((response) => {
                this.liste_anamneses = response
                if (this.liste_anamneses.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.anamnese_is_loading = false
            })
        },

        removeGroupAnamnese(group) {
            this.data_to_be_deleted = {
                libelle: group.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group.anamnese_group_id,
                data_type: 'anamnese'
            }
        }
    }
}


